export const openInNewTabDrive = (sharedDriveFolderId) => {
  const url = `https://drive.google.com/drive/folders/${sharedDriveFolderId}`;
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) {
    newWindow.opener = null;
  }
};
